import { Pipe, PipeTransform } from '@angular/core';
import { LoggerService } from '@wdpr/ra-angular-logger';

@Pipe({
  name: 'absTrimmer',
})
export class AbsTrimmerPipe implements PipeTransform {

  release = {
    dcl: {
      baseURL: 'https://disneycruise.disney.go.com'
    },
    dlr: {
      baseURL: 'https://disneyland.disney.go.com'
    },
    wdw: {
      baseURL: 'https://disneyworld.disney.go.com'
    }
  };

  baseUrl;
  localeRegex = /\/([a-z]{2}((_|-)[A-z]{2})?)(\/|$)/;

  constructor(private logger: LoggerService) { }

  // function(input, replaceProdUrl, appendLocale)
  transform(value: any, replaceProdUrl: Boolean, appendLocale: Boolean): any {
    // TODO: create service for wdprSiteId
    const wdprSiteId = 'dcl';

    if (!this.baseUrl) {
      this.baseUrl = '';
      this.baseUrl += window.location.protocol + '//';
      this.baseUrl += window.location.hostname;

      if (window.location.port !== '80' && window.location.port !== '443') {
        this.baseUrl += ':' + window.location.port;
      }
    }

    // In case appendLocale is true and the baseUrl does not yet contain the locale, add it
    if (appendLocale && !this.baseUrl.match(this.localeRegex)) {
      const locale = window.location.pathname.match(this.localeRegex);

      if (locale) {
        this.baseUrl += '/' + locale[1];
      }
    }

    let result = '';

    // Avoid failure when input is undefined
    if (typeof value === 'undefined') {
        return value;
    }

    if (replaceProdUrl === true) {
      // Specifically remove production URL and replace with environment URL
      if (this.release[wdprSiteId] && this.release[wdprSiteId].baseURL) {
        result = value.replace(new RegExp(this.urlToRegExpString(this.release[wdprSiteId].baseURL), 'g'), this.baseUrl);
      } else {
        this.logger.warn('absTrimmer filter called with an undefined siteId');
      }
    } else {
        // Force to environment specific URL regardless of domain.
        result = value.replace(/http(s)?:\/\/(.*?)\//g, this.baseUrl + '/');
    }

    // Default to homepage if empty and add a trailing slash
    if (result === '' || result === this.baseUrl) {
      result = this.baseUrl + '/';
    }

    return result;
  }

  urlToRegExpString(url) {
    return url.replace(/https/g, 'http(s)?').replace(/\//g, '\/').replace(/\./g, '\.');
  }

}
